import { useContext, useEffect } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Add } from '@mui/icons-material'
import { Box, Button } from '@mui/material'

import { ObjectShortDTO } from '@types'

import { PageContext } from '@gantt/components/GanttCreateOrEdit'
import { getBarDefaultValue } from '@gantt/helpers'

import { TimelineForm } from '../TimelineForm'

type TimelineFormArrayProps = {
  objects: ObjectShortDTO[] | undefined
  isLoadingObjects: boolean
  filteredObjects: ObjectShortDTO[] | undefined
  usedObjectsList: string[]
}

export const TimelineFormArray = ({
  objects,
  isLoadingObjects,
  filteredObjects,
  usedObjectsList,
}: TimelineFormArrayProps) => {
  const { t } = useTranslation()
  const methods = useFormContext()
  const { control, watch } = methods
  const { fields, append, remove: handleRemoveBar } = useFieldArray({ control, name: 'timeline' })
  const {
    handleEdit,
    handleOpenDialog,
    onSetSegmentToDelete: handleDeleteSegment,
    onSetActionToDeleteTimeline: handleDeleteActionTimeline,
    showDialog,
  } = useContext(PageContext)

  useEffect(() => {
    if (fields.length === 0) {
      handleAppend()
    }
  }, [])

  const handleAppend = () => {
    append(getBarDefaultValue())
  }

  return (
    <>
      <Box display='flex' justifyContent='end' pb={1}>
        <Button onClick={handleAppend}>
          <Add fontSize='small' />
          {t('ganttCreate.timelineForm.addBar')}
        </Button>
      </Box>
      {fields.map((field, index) => (
        <Box key={field.id} pt={4}>
          <TimelineForm
            filteredObjects={filteredObjects}
            index={index}
            isLoadingObjects={isLoadingObjects}
            isShowDialog={showDialog}
            isSingleBar={fields.length === 1}
            objects={objects}
            rows={watch(`timeline.${index}.actions`) || []}
            rowsSegmentTable={watch(`timeline.${index}.sections`) || []}
            usedObjectsList={usedObjectsList}
            onDelete={handleDeleteActionTimeline}
            onDeleteSegment={handleDeleteSegment}
            onEdit={handleEdit}
            onOpenDialog={handleOpenDialog}
            onRemoveBar={handleRemoveBar}
          />
        </Box>
      ))}
      <Box display='flex' justifyContent='end' pb={1}>
        <Button onClick={handleAppend}>
          <Add fontSize='small' />
          {t('ganttCreate.timelineForm.addBar')}
        </Button>
      </Box>
    </>
  )
}
